import React from "react";
import { makeStyles } from "@material-ui/core/styles";
//import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Divider from '@material-ui/core/Divider';
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Slide from "@material-ui/core/Slide";
//import VisibilityIcon from "@material-ui/icons/Visibility";
//import SaveIcon from "@material-ui/icons/Save";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
//import Card from '@material-ui/core/Card';
//import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
//import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { colors } from "@material-ui/core"
import Box from '@material-ui/core/Box';
import Grid from "@material-ui/core/Grid";
import moment from 'moment'
import { states, sources, periods, mandates, incomes, idTypes, statuses } from '../../../../utils/data'
import { countries } from '../../../../utils/countries'
import { nationalities } from '../../../../utils/nationalities'
import { branches } from '../../../../utils/branches'
import { Review } from './review'
import { QueryRecord } from './queryRecord'

const useStyles = makeStyles(theme => ({
  appBar: {
    position: "fixed",
    backgroundColor: colors.lightBlue[300],
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    fontSize: 13,
    fontWeight: 600
    // color: theme.palette.text.primary.light
  },
  formID: {
    // marginLeft: theme.spacing(2),
    flex: 1,
    fontSize: 18,
    fontWeight: 600,
    textColor: "#FFFFF"
  },
  title1: {
    color: colors.grey[900],
    marginLeft: theme.spacing(2),
    flex: 1,
    cursor: 'pointer'
  },
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(3)
    // maxWidth: 752,
  },
  icon: {
    marginLeft: theme.spacing(1),
    color: theme.palette.text.primary.light
  },
  demo: {
    backgroundColor: theme.palette.background.paper
  },
  modalTitle: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary.light
  },
  table: {
    minWidth: 100,
  },
  details: {
    color: colors.grey[900],
    backgroundColor: colors.lime[500],
    fontWeight: 800,
    fontSize: 13,
    height: 30,
  },
  contacts: {
    color: colors.grey[900],
    backgroundColor: colors.lightBlue[300],
    fontWeight: 800,
    fontSize: 13,
    height: 30,
  },
  value: {
    fontSize: 13,
    fontWeight: 550,
    textTransform: "uppercase",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const DataPreviewModal = ({ handleToggleSnackBar, handleOpenSnackError, fetchData, handleReveiw, openRow, handleClose, open }) => {
  // console.log('openRow>', openRow)
  let genderChecker = openRow[8] === '' ? 'M' : openRow[8];
  let sourcesOfIncomeChecker = openRow[26] === '' ? 'B' : openRow[26];
  let periodWithWorkplaceChecker = openRow[32] === '' ? 'L' : openRow[32];
  let monthlyGrossIncomeChecker = openRow[33] === '' ? 'B5' : openRow[33];
  let signingMandateChecker = openRow[34] === '' ? 'A' : openRow[34];
  let idTypeChecker = openRow[10] === '' ? 'N' : openRow[10];
  let branchChecker = openRow[6] === '' ? '0000' : openRow[6];

  let nationalityChecker = openRow[12] === '' ? 'AF' : openRow[12];
  let statusChecker = openRow[9] === '' ? 'S' : openRow[9];
  let countryChecker = openRow[13] === '' ? 'AF' : openRow[13];
  const othersourcesOfIncomeValue = openRow[27] === '' || openRow[27] === 'B' || openRow[27] === 'S' ? '...... N/A ......' : openRow[27];
  const alternativeSourceOfIncomeValue = openRow[28] === '' ? '..............' : openRow[28];
  const currentRoleValue = openRow[30] === '' ? '..............' : openRow[30];
  const workplaceAddressValue = openRow[31] === '' ? '..............' : openRow[31];
  const otherSigningMandateValue = openRow[35] === '' ? '...... N/A ......' : openRow[35];
  const currentEmployerValue = openRow[29] === '' || openRow[29] === 'OT' || openRow[29] === 'B' ? '...... N/A ......' : openRow[29];

  const bankNameDepositValue = openRow[36] !== '' ? openRow[36] : '............';
  const depositAccountNamesValue = openRow[37] !== '' ? openRow[37] : '............';
  const depositAccountNumberValue = openRow[38] ? openRow[38] : '............';
  const telecomNameValue = openRow[39] ? openRow[39] : '............';
  const registeredNamesValue = openRow[40] !== '' ? openRow[40] : '...........';
  const registeredNumberValue = openRow[41] !== '' ? openRow[41] : '............';
  const accountNumberValue = openRow[5] !== '' ? openRow[5] : '............';
  const accountNameValue = openRow[4] !== '' ? openRow[4] : '............';
  const dateValue = openRow[7] !== '' ? openRow[7] : '............';
  const surnameValue = openRow[2] !== '' ? openRow[2] : '............';
  const otherNameValue = openRow[3] !== '' ? openRow[3] : '............';
  const branchValue = branches.data.filter(bran => bran.SOL_ID === branchChecker)
  const countryValue = countries.data.filter(country => country.code === countryChecker)
  const nationalityValue = nationalities.data.filter(nation => nation.alpha_2_code === nationalityChecker)
  const genderValue = states.filter(state => state.value === genderChecker)
  const sourcesOfIncomeValue = sources.filter(source => source.value === sourcesOfIncomeChecker)
  const periodWithWorkplaceValue = periods.filter(period => period.value === periodWithWorkplaceChecker)
  const signingMandateValue = mandates.filter(mandate => mandate.value === signingMandateChecker)
  const monthlyGrossIncomeValue = incomes.filter(income => income.value === monthlyGrossIncomeChecker)
  const idTypeValue = idTypes.filter(type => type.value === idTypeChecker)
  const statusValue = statuses.filter(state => state.value === statusChecker)
  const expiryDateValue = openRow[15] === '' ? '........' : moment(openRow[15]).format('MMMM Do YYYY');
  const dateOfBirthValue = openRow[11] === '' ? '........' : moment(openRow[11]).format('MMMM Do YYYY');

  const classes = useStyles();

  function createData(label, value) {
    return { label, value };
  }

  const basic = [
    createData('Branch', branchValue[0].SOL_DESC),
    createData('Account Number', accountNumberValue),
    createData('Account Name', accountNameValue),
    createData('Date', moment(dateValue).format('MMMM Do YYYY')),
  ];

  const details = [
    createData('Surname', surnameValue),
    createData('Other Names', otherNameValue),
    createData('Gender', genderValue[0].label),
    createData('Marital Status', statusValue[0].label),
    createData('Date of Birth', dateOfBirthValue),
    createData('Nationality', nationalityValue[0].nationality),
    createData('Country of Residence', countryValue[0].name),
    createData('ID Card Type', idTypeValue[0].label),
    createData('ID Card Number', openRow[14]),
    createData('ID Card Expiry Date', expiryDateValue),
  ];

  const contacts = [
    createData('Mobile Phone', `${openRow[24]} - ${openRow[16]}`),
    createData('Other Number', openRow[17]),
    createData('P.O.Box Number and location', `${openRow[18]} - ${openRow[19]}`),
    createData('Personal Email', openRow[20]),
  ];

  const nokContacts = [
    createData('Names', openRow[45]),
    createData('Address', openRow[48]),
    createData('Email', openRow[46]),
    createData('Relationship', openRow[49]),
    createData('Telephone No.', openRow[47]),
  ];

  const residentials = [
    createData('State / City / District', openRow[21]),
    createData('Province / County', openRow[22]),
    createData('Village', openRow[23]),
    createData('Zone/ Plot No. / Street ', openRow[25]),
  ];

  const employment = [
    createData('Source of Income', sourcesOfIncomeValue[0].label),
    createData('Other source of Income', othersourcesOfIncomeValue),
    createData('Current Role', currentRoleValue),
    createData('Current Employer', currentEmployerValue),
    createData('Monthly Gross Income', monthlyGrossIncomeValue[0].label),
    createData('Period With Work Place', periodWithWorkplaceValue[0].label),
    createData('Signing Mandate', signingMandateValue[0].label),
    createData('Other Signing Mandate', otherSigningMandateValue),
    createData('Work Place Address', workplaceAddressValue),
    createData('Any other Alternative Source Of Income', alternativeSourceOfIncomeValue),
    createData('Policy', <CheckBoxIcon color="secondary" />),
  ];

  const depositBank = [
    createData('Bank Name', bankNameDepositValue),
    createData('Bank Account Name', depositAccountNamesValue),
    createData('Bank Account Number', depositAccountNumberValue),
  ];

  const depositTelecom = [
    createData(' Telecom Name', telecomNameValue),
    createData('Registered Names', registeredNamesValue),
    createData('Registered Number', registeredNumberValue),
  ];

  const deposit = openRow[36] !== '' || openRow[37] !== '' || openRow[37] !== '' ? depositBank : depositTelecom;
  const [openQuery, setOpenQuery] = React.useState(false);
  const handleClickOpenQuery = () => {
    setOpenQuery(true);
  };

  const handleCloseQuery = () => {
    setOpenQuery(false);
  };
  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color={colors.grey[900]}
              onClick={handleClose}
              aria-label="close"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title1} onClick={handleClose}>
              Back to Clients
            </Typography>
            <Typography variant="h6" className={classes.title1} onClick={handleClose}>
            </Typography>
            <Typography variant="h6" className={classes.title1} >
              <span color="secondary" className={classes.formID}>{openRow[1]}</span>
            </Typography>
            <Typography variant="h6" className={classes.title1} >
              <QueryRecord handleOpenSnackError={handleOpenSnackError} handleToggleSnackBar={handleToggleSnackBar} handleClosePreview={handleClose}
                accountNumberValue={accountNumberValue} formIdValue={openRow[1]} handleReveiw={handleReveiw}
                //handleClosePreview={handleClose} handleClickOpenQuery={handleClickOpenQuery}
                handleCloseQuery={handleCloseQuery} setOpenQuery={setOpenQuery} openQuery={openQuery} />
            </Typography>
            <Review handleToggleSnackBar={handleToggleSnackBar} handleClosePreview={handleClose}
              handleReveiw={handleReveiw} formIdValue={openRow[1]} handleClickOpenQuery={handleClickOpenQuery}
              handleCloseQuery={handleCloseQuery} setOpenQuery={setOpenQuery} openQuery={openQuery} />
          </Toolbar>
        </AppBar>
        <div className={classes.root}>
          <DialogTitle id="customized-dialog-title">
            <Typography variant="h6" className={classes.modalTitle}>
              {/* Please Preview your information before you submit ! */}
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'>Basic Information</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {basic.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'>&nbsp;Applicant Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {details.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.contacts} colSpan='2'>&nbsp;Contact Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {contacts.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'>&nbsp;Next of Kin Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {nokContacts.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.contacts} colSpan='2'>&nbsp;Current Residential Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {residentials.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'>&nbsp;Employment / Business Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {employment.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'>&nbsp;Deposit Protection Fund</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {deposit.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell align="left">{row.label}</TableCell>
                          <TableCell className={classes.value} align="left">{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box my={5}>
                  <Typography align="center">
                    <li>Customer Deposits are protected by the Deposit Protection Fund of Uganda.</li>
                  </Typography>
                </Box>
                <Box my={1}>
                  <Typography align="center">
                    <li>PostBank is regulated by the Central Bank of Uganda.</li>
                  </Typography>
                </Box>
              </Grid>
            </Grid><br />
            <Divider variant="middle" /><br />
            {/* second row */}
            {/*  */}
          </DialogContent>
          <Divider variant="middle" />
        </div>
      </Dialog>
    </div>
  );
};

export default DataPreviewModal;
